// extracted by mini-css-extract-plugin
export default {"container":"AppointmentDetails_container__lKSa-"};